import React from 'react';
import Mapir from "mapir-react-component";
import { Navigation } from "lucide-react";
import locationIcon from "../assets/icons/Location.svg";
import 'mapir-react-component/dist/index.css';
import 'mapbox-gl/dist/mapbox-gl.css';

interface MapComponentProps {
  mapUrl?: string;
  latitude?: number;
  longitude?: number;
  name?: string
}

const MapComponent: React.FC<MapComponentProps> = ({ mapUrl, latitude, longitude, name }) => {
  const hasCoordinates = latitude != null && longitude != null;
  const directionsUrl = hasCoordinates
    ? `https://www.google.com/maps/dir/?api=1&destination=${longitude},${latitude}`
    : undefined;

  // Initialize Map component
  const Map = Mapir.setToken({
    transformRequest: (url: string) => {
      return {
        url: url,
        headers: {
          'x-api-key': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjIyMWQ4ZjM4MDgxNTA1YTMwNWNhZTY4YWNmMzcwNmRhYzU5YmI5YzllM2NlM2M1ZTFiNWZhY2FhZTc2MjdlMTQ5MjAyNWViODVlZDVkN2I5In0.eyJhdWQiOiIzMTYyNiIsImp0aSI6IjIyMWQ4ZjM4MDgxNTA1YTMwNWNhZTY4YWNmMzcwNmRhYzU5YmI5YzllM2NlM2M1ZTFiNWZhY2FhZTc2MjdlMTQ5MjAyNWViODVlZDVkN2I5IiwiaWF0IjoxNzQyNjI0NDM0LCJuYmYiOjE3NDI2MjQ0MzQsImV4cCI6MTc0NTIxNjQzNCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.DjwfXfL1bo4S0um881R_eeKxPXnQQCntmZbv3E0mw-9pthimlAiQHDDc9k-UjR94d0ZA6y3mmKn5UFJ9O-isMC9kCsLz0jVsqHaZXHUBkY5ijHi8rytRs_EfW12lZBdZ35WQejYRB1umr865eObl-EkSpFB_F4JjqCPbeeoi6P-5g5W68nHQwe17fkIBhHi610vh6sI5bmWRkjhZaKbn5FGrkpbvBkuEsDUj2Toxcir4OR0UR1SCD5L7I69SsvvSke44JWrPk--NVFIPgb24sC5scqcIG8oGh-WYTEvLB9cT6XkZLfFOiG0eK1lYSeKZniLOB6v47MmKKKhwvW067A',
          'Mapir-SDK': 'reactjs'
        }
      };
    }
  });

  return (
    <section className="w-full rounded-xl bg-[#FAFAFA] p-4 tablet:p-6">
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="text-[1.09rem] font-myYekanDemibold leading-[1.5] text-[#222222]">نقشه</h2>
        {directionsUrl && (
          <a
            href={directionsUrl}
            target="_blank"
            rel="noreferrer"
            aria-label={`مسیریابی به ${name || "مکان"}`}
            className="inline-flex h-10 shrink-0 items-center justify-center gap-2 rounded-xl border border-[#038545] bg-white px-3 text-xs font-myYekanDemibold text-[#068646] transition-colors hover:bg-[#f3fefa] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#038545] focus-visible:ring-offset-2"
          >
            <Navigation size={16} aria-hidden="true" />
            <span>مسیریابی</span>
          </a>
        )}
      </div>

      <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">

        {hasCoordinates ? (
          <Mapir
            center={[longitude, latitude]}
            Map={Map}
            zoom={[15]}
            interactive={true}
            hash={false}
            trackResize={true}
            containerStyle={{
              width: '100%',
              height: '200px'
            }}
          >
            <Mapir.Marker
              coordinates={[longitude, latitude]}
              anchor="center"
              Image={locationIcon}
            />
            <Mapir.Popup 
              coordinates={[longitude, latitude]}
              anchor="top"
              offset={[0, 30]}
            >
              <div className="text-[0.77rem] leading-[1.5] text-gray-800 font-myYekanMedium">
                {name}
              </div>
            </Mapir.Popup>
          </Mapir>
        ) : (
          <div className="py-8 text-center text-[0.77rem] leading-[1.8] text-gray-500 font-myYekanRegular">
            اطلاعات موقعیت مکانی موجود نیست
          </div>
        )}
      </div>

    </section>
  );
};

export default MapComponent;
